// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/header.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/dash_benefits_banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_container {
    width: 100%;
    min-height: 100%;
    display: grid;
    grid-template-columns: 16% 84%;
    background-color: #F2F2F4;
    position: relative;
    z-index: 99!important;
}
.dashboard_hide_sidebar {
    width: 100%;
    min-height: 100%;
    display: grid;
    grid-template-columns: 90px 1fr;
    background-color: #F2F2F4;
}

@media (max-width: 1000px) {
    .dashboard_hide_sidebar {
        display: block;
    }
}

.dashboard_banner_img {
    width: 100%;
    height: 100%;
}
.main_sections {
    max-width: 100vw;
    width: 100%;
    display: grid;
    grid-template-columns: 75% 25%;
}

.dashboard_settings_container {
    height: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
}
.export_button {
    width: 140px;
    height: 40px;
    background-color: #EDEEF4;
    border-radius: 7px;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 15px;
    font-size: 16px;
}
.dashboard_main_banner {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 175px;
}
@media (max-width: 1000px) {
    .dashboard_main_banner {
        background-position: left;
    }
}
.summary_chart_grid {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 50% 50%;
}
@media (max-width: 900px) {
    .summary_chart_grid {
        display: block;
    }
}
.right_section {
    padding: 0 20px 20px 0;
}
@media (max-width: 1000px) {
    .responsive_side {
        min-width: 95vw;
        max-width: 95vw;
        margin-left: auto;
        margin-right: auto;
    }
    .right_section {
        margin-left: auto;
        margin-right: auto;
        max-width: 96vw;
        width: 100%;
        padding: 0;
        margin-bottom: 40px;
    }
}

.second_side {
    height: 605px;
}

.right_section_content {
    width: 100%;
    height: 100%;
    border-radius: 15px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
}
.top_side {
    width: 100%;
    border-radius: 15px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    height: 918px;
}
.top_bottom {
    position: relative;
    height: 770px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: 140% 140%;
}
.btn_ben {
    position: absolute;
    width: 150px;
    left: 15px;
    bottom: 25px;
}

.benefits_banner_text {
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 10px;
    color: white;
    font-weight: 300;
    text-align: center;
}
.benefits_banner_img {
    width: 100%;
}
/* NEED ANOTHER IMAGE WITHOUT PADDINGS */
.benefits_banner_img > img {
    margin-top: -90px;
    max-width: 100%;
}
.left_section_first {
    width: 100%;
    max-width: 100%;
    padding: 20px;
    margin-top: 30px;
}
.left_section_charts {
    width: 100%;
    min-height: 320px;
    padding: 20px;
}

.left_section_first_top {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}
.download_btn {
    width: 70%;
    min-width: 120px;
    margin-right: 1rem;
    cursor: pointer;
}
@media (max-width: 700px) {
    .left_section_first_top {
        display: block;
    }
    .left_section_charts {
        padding: 10px;
    }
}

.profile_completion_invoices_container {
    padding-left: 35px;
    padding-top: 20px;
}

.profile_completion_invoices_container > h2 {
    font-size: 18px;
    font-weight: 700;
    color: #FFFFFF;
}

.profile_completion_invoices_container > p {
    font-size: 14px;
    font-weight: 300;
    color: #FFFFFF;
    max-width: 300px;
}

.dash_first_one {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    width: 100%;
    height: 100%;
    background-color: white;
}
.left_section_first_bottom {
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    height: 70%;
    box-sizing: border-box;
}

.month_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    background: rgb(14,0,247);
    background: linear-gradient(0deg, rgba(14,0,247,0.0844712885154062) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,1) 100%);
    background: -webkit-linear-gradient(bottom,rgba(14,0,247,0.1),rgba(255,255,255,0.3) 45%,rgba(255,255,255,0));
}
.month_text {
    font-size: 20px;
    padding-left: 15px;
    font-weight: 600;
}
.crown_prod {
    width: 100%;
    margin-top: 50px;
    display: flex;
    justify-content: center;
}
.crown_prod > img {
    width: 80px;
}
.prod_main_text {
    padding-top: 10px;
    font-size: 26px;
    font-weight: 600;
    text-align: center;
}
.dash_first_three {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
}
.left_section_second_top {
    width: 100%;
    height: 50%;
}
.dash_second_container {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    width: 100%;
    height: 100%;
    position: relative;
}
.dash_table_container {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    width: 100%;
    height: 100%;
    position: relative;
    background-color: white;
    max-width: 87vw;
}

@media (max-width: 800px) {
    .dash_table_container {
        max-width: 96vw;
    }
}

.dash_benefits_container {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    width: 100%;
    height: 650px;
    position: relative;
    background-color: white;
}
/* USING ONLY FOR CHARTS IN DASHBOARD */
.grid {
    display: grid;
    grid-template-columns: 50% 50%;
}
.vl {
    width: 1px;
    height: 100%;
    background-color: #CDE1EB;
    left: 50%;
    position: absolute;
}
.dash_second_one {
    width: 100%;
    height: 100%;
}
.left_section_second_bottom {
    max-width: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
}
@media (max-width: 700px) {
    .left_section_second_bottom {
        padding: 0 20px 20px 0;
    }
}
@media (max-width: 600px) {
    .left_section_second_bottom {
        padding: 0;
    }
}
.dash_third {
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    width: 100%;
    max-width: 82vw;
    height: 100%;
}
.main_large_block {
    width: 100%;
    height: 600px;
    margin-bottom: 20px;
    padding: 20px;
}
.main_large_block_content {
    width: 100%;
    height: 100%;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    padding: 20px;
}

.main_large_block_content_row {
    width: 100%;
    height: 100%;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5%;
}
.dash-bottom {
    height: 300px;
    background: rgb(14,0,247);
    background: linear-gradient(0deg, rgba(14,0,247,0.0844712885154062) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,1) 100%);
    background: -webkit-linear-gradient(bottom,rgba(14,0,247,0.1),rgba(255,255,255,0.3) 55%,rgba(255,255,255,0));
    display: grid;
    grid-template-columns: 40% 60%;
}
.dash-bottom > img {
    margin-left: 2%;
    margin-top: 5%;
    max-height: 260px;
}

.welcome_button {
    position: absolute;
    bottom: 20px;
    right: 10px;
    width: 160px;
}

/* NEW EMPLOYEE */
.dash_last_employee_container {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
}
.employee_image {
    width: 45px;
    height: 45px;
    margin-right: 20px;
    border-radius: 50%;
}
.employee_name {
    font-size: 16px;
    font-weight: 600;
    color: #7a7a7a;
}
.employee_role {
    font-size: 11px;
    font-weight: 500;
    color: #767493;
    letter-spacing: 0.5px;
}

/* DOWNLOAD SECTION */

.download_title {
    color: #242424;
    font-size: 28px;
    margin-bottom:15px;
}

.download_image {
    max-height: 240px;
}

/* LIST MERCHANT */
.dash_list_container {
    padding: 20px;
}

/* HELP SECTION */
.dash_help_title {
    font-size: 18px;
    padding-top: 10px;
    padding-bottom: 15px;
}
.dash_help_text {
    font-size: 10px;
    color: #9B9B9B;
}


/* CONTAINERS TITLES */

.dash_container_top {
    width: 90%;
    padding-top: 15px;
    padding-bottom: 15px;
    margin-left: auto;
    margin-right: auto;
    font-size: 18px;
}

.dash_container_more,
.dash_container_more a {
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: #7C828A;
    padding-right: 10px;
    text-decoration: none;
}
@media (max-width: 600px) {
    .dash_container_more,
    .dash_container_more a {
        font-size: 12px;
    }
}
.dash_container_more:hover,
.dash_container_more a:hover {
    color: #999999;
}


@media (max-width: 1400px) {
    .prod_main_text {
        font-size: 22px;
    }
}

@media (max-width: 1330px) {
    .welcome_right {
        grid-template-rows: 38% 62%;
    }
}

@media (max-width: 1300px) {
    .dashboard_container {
        grid-template-columns: 1fr;
    }
    .settings_image_box {
        display: flex;
        justify-content: flex-end;
    }
}

@media (max-width: 1200px) {
    .main_sections {
        grid-template-columns: 1fr;
    }
    .left_section_first {
        max-width: 96vw;
        margin-left: auto;
        margin-right: auto;
        padding: 0;
    }
    .welcome_image {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,yDAA6C;IAC7C,iCAAiC;IACjC,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;AACA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;QACI,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IAEnB,+CAA+C;AACnD;AACA;IACI,WAAW;IACX,mBAAmB;IAEnB,+CAA+C;IAC/C,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,yDAA2D;IAC3D,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA,wCAAwC;AACxC;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IAEI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,0HAA0H;IAC1H,4GAA4G;AAChH;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IAEI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IAEI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAEI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IAEI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;AACA,uCAAuC;AACvC;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IAEI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IAEZ,+CAA+C;IAC/C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IAEZ,+CAA+C;IAC/C,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,0HAA0H;IAC1H,4GAA4G;IAC5G,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA,qBAAqB;;AAErB;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA,sBAAsB;;AAEtB;IACI,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI;;QAEI,eAAe;IACnB;AACJ;AACA;;IAEI,cAAc;AAClB;;;AAGA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".dashboard_container {\n    width: 100%;\n    min-height: 100%;\n    display: grid;\n    grid-template-columns: 16% 84%;\n    background-color: #F2F2F4;\n    position: relative;\n    z-index: 99!important;\n}\n.dashboard_hide_sidebar {\n    width: 100%;\n    min-height: 100%;\n    display: grid;\n    grid-template-columns: 90px 1fr;\n    background-color: #F2F2F4;\n}\n\n@media (max-width: 1000px) {\n    .dashboard_hide_sidebar {\n        display: block;\n    }\n}\n\n.dashboard_banner_img {\n    width: 100%;\n    height: 100%;\n}\n.main_sections {\n    max-width: 100vw;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 75% 25%;\n}\n\n.dashboard_settings_container {\n    height: 30px;\n    margin-bottom: 30px;\n    display: flex;\n    justify-content: flex-end;\n    padding-right: 20px;\n}\n.export_button {\n    width: 140px;\n    height: 40px;\n    background-color: #EDEEF4;\n    border-radius: 7px;\n    cursor: pointer;\n    padding-left: 20px;\n    padding-right: 15px;\n    font-size: 16px;\n}\n.dashboard_main_banner {\n    position: relative;\n    background-image: url('../../img/header.svg');\n    background-position: right bottom;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    height: 175px;\n}\n@media (max-width: 1000px) {\n    .dashboard_main_banner {\n        background-position: left;\n    }\n}\n.summary_chart_grid {\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    display: grid;\n    grid-template-columns: 50% 50%;\n}\n@media (max-width: 900px) {\n    .summary_chart_grid {\n        display: block;\n    }\n}\n.right_section {\n    padding: 0 20px 20px 0;\n}\n@media (max-width: 1000px) {\n    .responsive_side {\n        min-width: 95vw;\n        max-width: 95vw;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    .right_section {\n        margin-left: auto;\n        margin-right: auto;\n        max-width: 96vw;\n        width: 100%;\n        padding: 0;\n        margin-bottom: 40px;\n    }\n}\n\n.second_side {\n    height: 605px;\n}\n\n.right_section_content {\n    width: 100%;\n    height: 100%;\n    border-radius: 15px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n}\n.top_side {\n    width: 100%;\n    border-radius: 15px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    height: 918px;\n}\n.top_bottom {\n    position: relative;\n    height: 770px;\n    background-image: url(\"../../img/dash_benefits_banner.png\");\n    background-position: center;\n    background-size: 140% 140%;\n}\n.btn_ben {\n    position: absolute;\n    width: 150px;\n    left: 15px;\n    bottom: 25px;\n}\n\n.benefits_banner_text {\n    font-family: Montserrat, sans-serif;\n    font-size: 18px;\n    max-width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 10px;\n    color: white;\n    font-weight: 300;\n    text-align: center;\n}\n.benefits_banner_img {\n    width: 100%;\n}\n/* NEED ANOTHER IMAGE WITHOUT PADDINGS */\n.benefits_banner_img > img {\n    margin-top: -90px;\n    max-width: 100%;\n}\n.left_section_first {\n    width: 100%;\n    max-width: 100%;\n    padding: 20px;\n    margin-top: 30px;\n}\n.left_section_charts {\n    width: 100%;\n    min-height: 320px;\n    padding: 20px;\n}\n\n.left_section_first_top {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n}\n.download_btn {\n    width: 70%;\n    min-width: 120px;\n    margin-right: 1rem;\n    cursor: pointer;\n}\n@media (max-width: 700px) {\n    .left_section_first_top {\n        display: block;\n    }\n    .left_section_charts {\n        padding: 10px;\n    }\n}\n\n.profile_completion_invoices_container {\n    padding-left: 35px;\n    padding-top: 20px;\n}\n\n.profile_completion_invoices_container > h2 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #FFFFFF;\n}\n\n.profile_completion_invoices_container > p {\n    font-size: 14px;\n    font-weight: 300;\n    color: #FFFFFF;\n    max-width: 300px;\n}\n\n.dash_first_one {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n}\n.left_section_first_bottom {\n    margin-top: 20px;\n    width: 100%;\n    max-width: 100%;\n    height: 70%;\n    box-sizing: border-box;\n}\n\n.month_box {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    background: rgb(14,0,247);\n    background: linear-gradient(0deg, rgba(14,0,247,0.0844712885154062) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,1) 100%);\n    background: -webkit-linear-gradient(bottom,rgba(14,0,247,0.1),rgba(255,255,255,0.3) 45%,rgba(255,255,255,0));\n}\n.month_text {\n    font-size: 20px;\n    padding-left: 15px;\n    font-weight: 600;\n}\n.crown_prod {\n    width: 100%;\n    margin-top: 50px;\n    display: flex;\n    justify-content: center;\n}\n.crown_prod > img {\n    width: 80px;\n}\n.prod_main_text {\n    padding-top: 10px;\n    font-size: 26px;\n    font-weight: 600;\n    text-align: center;\n}\n.dash_first_three {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n}\n.left_section_second_top {\n    width: 100%;\n    height: 50%;\n}\n.dash_second_container {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n.dash_table_container {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background-color: white;\n    max-width: 87vw;\n}\n\n@media (max-width: 800px) {\n    .dash_table_container {\n        max-width: 96vw;\n    }\n}\n\n.dash_benefits_container {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    width: 100%;\n    height: 650px;\n    position: relative;\n    background-color: white;\n}\n/* USING ONLY FOR CHARTS IN DASHBOARD */\n.grid {\n    display: grid;\n    grid-template-columns: 50% 50%;\n}\n.vl {\n    width: 1px;\n    height: 100%;\n    background-color: #CDE1EB;\n    left: 50%;\n    position: absolute;\n}\n.dash_second_one {\n    width: 100%;\n    height: 100%;\n}\n.left_section_second_bottom {\n    max-width: 100%;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr;\n}\n@media (max-width: 700px) {\n    .left_section_second_bottom {\n        padding: 0 20px 20px 0;\n    }\n}\n@media (max-width: 600px) {\n    .left_section_second_bottom {\n        padding: 0;\n    }\n}\n.dash_third {\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    width: 100%;\n    max-width: 82vw;\n    height: 100%;\n}\n.main_large_block {\n    width: 100%;\n    height: 600px;\n    margin-bottom: 20px;\n    padding: 20px;\n}\n.main_large_block_content {\n    width: 100%;\n    height: 100%;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    padding: 20px;\n}\n\n.main_large_block_content_row {\n    width: 100%;\n    height: 100%;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    border-radius: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5%;\n}\n.dash-bottom {\n    height: 300px;\n    background: rgb(14,0,247);\n    background: linear-gradient(0deg, rgba(14,0,247,0.0844712885154062) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,1) 100%);\n    background: -webkit-linear-gradient(bottom,rgba(14,0,247,0.1),rgba(255,255,255,0.3) 55%,rgba(255,255,255,0));\n    display: grid;\n    grid-template-columns: 40% 60%;\n}\n.dash-bottom > img {\n    margin-left: 2%;\n    margin-top: 5%;\n    max-height: 260px;\n}\n\n.welcome_button {\n    position: absolute;\n    bottom: 20px;\n    right: 10px;\n    width: 160px;\n}\n\n/* NEW EMPLOYEE */\n.dash_last_employee_container {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 30px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    gap: 20px;\n}\n.employee_image {\n    width: 45px;\n    height: 45px;\n    margin-right: 20px;\n    border-radius: 50%;\n}\n.employee_name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #7a7a7a;\n}\n.employee_role {\n    font-size: 11px;\n    font-weight: 500;\n    color: #767493;\n    letter-spacing: 0.5px;\n}\n\n/* DOWNLOAD SECTION */\n\n.download_title {\n    color: #242424;\n    font-size: 28px;\n    margin-bottom:15px;\n}\n\n.download_image {\n    max-height: 240px;\n}\n\n/* LIST MERCHANT */\n.dash_list_container {\n    padding: 20px;\n}\n\n/* HELP SECTION */\n.dash_help_title {\n    font-size: 18px;\n    padding-top: 10px;\n    padding-bottom: 15px;\n}\n.dash_help_text {\n    font-size: 10px;\n    color: #9B9B9B;\n}\n\n\n/* CONTAINERS TITLES */\n\n.dash_container_top {\n    width: 90%;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 18px;\n}\n\n.dash_container_more,\n.dash_container_more a {\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    color: #7C828A;\n    padding-right: 10px;\n    text-decoration: none;\n}\n@media (max-width: 600px) {\n    .dash_container_more,\n    .dash_container_more a {\n        font-size: 12px;\n    }\n}\n.dash_container_more:hover,\n.dash_container_more a:hover {\n    color: #999999;\n}\n\n\n@media (max-width: 1400px) {\n    .prod_main_text {\n        font-size: 22px;\n    }\n}\n\n@media (max-width: 1330px) {\n    .welcome_right {\n        grid-template-rows: 38% 62%;\n    }\n}\n\n@media (max-width: 1300px) {\n    .dashboard_container {\n        grid-template-columns: 1fr;\n    }\n    .settings_image_box {\n        display: flex;\n        justify-content: flex-end;\n    }\n}\n\n@media (max-width: 1200px) {\n    .main_sections {\n        grid-template-columns: 1fr;\n    }\n    .left_section_first {\n        max-width: 96vw;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 0;\n    }\n    .welcome_image {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
